module.exports = __webpack_public_path__ + "3e530b200a3a49fb5fed13220da79911.svg";